
import { createStore } from "vuex";
import Cookies from "js-cookie";
import classes from "./modules/classes";
import groups from "./modules/groups";
import students from "./modules/students";
import teacher from "./modules/teacher";
import groupstudent from "./modules/groupstudent";
import guardian from "./modules/guardian";
import studentGuardian from "./modules/studentGuardian";
import subjects from "./modules/subjects";
import chapters from "./modules/chapters";
import classsubjects from "./modules/classSubjects";
import topics from "./modules/topics";
import chapterSubjects from "./modules/chapterSubjects";
import schedules from "./modules/schedules";
import examSchedules from "./modules/examSchedules";
import assignments from "./modules/assignments";
import questions from "./modules/questions";
import questionForms from "./modules/questionForms";
import announcements from "./modules/announcements";
import gradeSheets from "./modules/gradeSheets";
import payments from "./modules/payments";
import guardianWallet from "./modules/guardianWallet";
import examTypes from "./modules/examTypes";
import api from "@/api";
import buses from "./modules/buses";
import areas from "./modules/areas";
import salaryManagement from "./modules/salaryManagement";
import employee from "./modules/employee";
import { initEcho } from "../../resources/js/echo.js";

export default createStore({
  modules: {
    classes,
    groups,
    students,
    groupstudent,
    teacher,
    guardian,
    studentGuardian,
    subjects,
    chapters,
    classsubjects,
    chapterSubjects,
    topics,
    schedules,
    examSchedules,
    assignments,
    questions,
    questionForms,
    announcements,
    gradeSheets,
    payments,
    guardianWallet,
    examTypes,
    buses,
    areas,
    salaryManagement,
    employee,
  },
  state: {
    user: JSON.parse(localStorage.getItem("user")) || null,
    token: localStorage.getItem("token") || Cookies.get("token") || null,
    tenant: JSON.parse(localStorage.getItem("tenant")) || null, 
    users: [],
    roles: [],
    currentPage: 1,
    totalPages: 1,
    isLoading: false,
    error: null,
    permSlugs: new Set(JSON.parse(localStorage.getItem("perm_slugs") || "[]")),
    permissionsReady: false,
      tenants: [],
  },
  mutations: {
  SET_TENANTS(state, tenants) {
  state.tenants = tenants;
},
    SET_TENANT(state, tenant) {
  state.tenant = tenant;
  localStorage.setItem("tenant", JSON.stringify(tenant));
  Cookies.set("tenant_slug", tenant?.slug || "", { expires: 7 });
},

CLEAR_TENANT_DATA(state) {
  state.users = [];
  state.roles = [];
},
    SET_PERMISSIONS(state, slugs) {
      const arr = Array.isArray(slugs) ? slugs : [];
      state.permSlugs = new Set(arr);
      localStorage.setItem("perm_slugs", JSON.stringify(arr));
      state.permissionsReady = true;
    },
    
    SET_PERMISSIONS_READY(state, val) {
      state.permissionsReady = !!val;
    },

    SET_USER(state, { token, user, tenant }) {
      state.token = token;
      state.user = user;
      if (tenant) state.tenant = tenant;

      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));
      if (tenant) localStorage.setItem("tenant", JSON.stringify(tenant));
      
      Cookies.set("token", token, { expires: 7 });

      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    },
    
    SET_CURRENT_USER(state, user) {
      if (user && user.role) {
        user.role = {
          id: user.role.id || user.role_id,
          slug: user.role.slug || user.role_slug,
          name: user.role.name || "Unknown",
        };
      }
      state.user = user;
      localStorage.setItem("user", JSON.stringify(user));
    },

    SET_TOKEN(state, token) {
      state.token = token;
      localStorage.setItem("token", token);
      Cookies.set("token", token, { expires: 7 });
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    },

    LOGOUT(state) {
      state.user = null;
      state.token = null;
      state.tenant = null; 

      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("perm_slugs");
      localStorage.removeItem("tenant"); 

      state.permSlugs = new Set();
      state.permissionsReady = false;

      Cookies.remove("token");
      Cookies.remove("user_type");
      delete api.defaults.headers.common["Authorization"];

      if (window.Echo) {
        try { window.Echo.disconnect(); } catch { /* ignore */ }
        window.Echo = null;
      }
    },

    SET_USERS(state, users) {
      state.users = users;
      state.permissions =
        users && users.role && users.role.permissions
          ? users.role.permissions.map((p) => p.slug)
          : [];
    },
    
    SET_PAGINATION(state, { currentPage, totalPages }) {
      state.currentPage = currentPage;
      state.totalPages = totalPages;
    },
    
    SET_LOADING(state, isLoading) {
      state.isLoading = isLoading;
    },
    
    SET_ERROR(state, error) {
      state.error = error;
    },
    
    ADD_USER(state, user) {
      state.users.push(user);
    },
    
    UPDATE_USER(state, payload) {
      if (!payload || typeof payload !== "object") {
        console.error("[Vuex] UPDATE_USER: Invalid payload", payload);
        return;
      }

      if (!payload.id) {
        console.error("[Vuex] UPDATE_USER: Missing user ID", payload);
        return;
      }

      const index = state.users.findIndex((u) => u.id === payload.id);

      if (index === -1) {
        console.warn(`[Vuex] UPDATE_USER: User ${payload.id} not found in store`);
        return;
      }

      const updatedUser = {
        ...state.users[index],
        ...payload,
      };

      state.users = [
        ...state.users.slice(0, index),
        updatedUser,
        ...state.users.slice(index + 1),
      ];
    },
    
    SET_ROLES(state, roles) {
      state.roles = roles;
    },
  },
  
  actions: {
    async fetchTenants({ commit }) {
  const { data } = await api.get("/tenants");
  commit("SET_TENANTS", data);
  return data;
},

async switchTenant({ commit, dispatch }, tenant) {
  commit("SET_TENANT", tenant);
  commit("CLEAR_TENANT_DATA");

  try {
    await dispatch("loadMyPermissions");
    await dispatch("fetchRoles");
    await dispatch("fetchUsers");
  } catch (error) {
    console.error("Failed to switch tenant:", error.response?.data || error);
  }
},
    async loadMyPermissions({ commit }) {
      try {
        const { data } = await api.get("/me/permissions"); 
        const granted = (data?.granted || data || []).map((p) =>
          typeof p === "string" ? p : String(p.slug)
        );
        commit("SET_PERMISSIONS", granted);
      } catch (err) {
        console.error("loadMyPermissions failed:", err);
        commit("SET_PERMISSIONS", []);
      }
    },
    
    async loginUser({ commit }, credentials) {
      commit("LOGOUT");

      const response = await api.post("/login", credentials);

      const userData = { ...response.data.user, role: response.data.role };
      const tenantData = response.data.tenant; // Get tenant data from response

      commit("SET_TOKEN", response.data.token);
      commit("SET_CURRENT_USER", userData);
      if (tenantData) commit("SET_TENANT", tenantData); // Set tenant in store
      commit("SET_PERMISSIONS", response.data.permission_slugs || []);

      Cookies.set("user_type", response.data.role.slug, { expires: 7 });
      Cookies.set("user_name", response.data.user.name, { expires: 7 });
      
      if (tenantData && tenantData.slug) {
        Cookies.set("tenant_slug", tenantData.slug, { expires: 7 });
      }

      initEcho();

      return response.data;
    },

    logoutUser({ commit }) {
      commit("LOGOUT");
    },
    
    async fetchUsers({ commit, state }) {
      try {
        const token = state.token || Cookies.get("token");
        if (!token) {
          throw new Error("Authentication token not found");
        }
        const response = await api.get("/users");
        commit("SET_USERS", response.data);
      } catch (error) {
        commit("SET_ERROR", error.response?.data?.message || error.message);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    
    async fetchCurrentUser({ commit, state }) {
      try {
        if (state.user) return state.user;

        const token = state.token || Cookies.get("token");
        if (!token) throw new Error("No token available");

        api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

        const response = await api.get("/me");
        commit("SET_CURRENT_USER", response.data);
        return response.data;
      } catch (error) {
        commit("LOGOUT");
        throw error;
      }
    },
    
    async fetchUser({ commit, state }, userId) {
      try {
        const token = state.token || Cookies.get("token");
        if (!token) {
          throw new Error("Authentication token not found");
        }

        const response = await api.get(`/users/${userId}`);

        return response.data;
      } catch (error) {
        console.error("Failed to fetch user:", error);

        if (error.response?.status === 401) {
          commit("LOGOUT");
          window.location.reload(); 
        }

        throw error;
      }
    },

    async updateUser({ commit, state }, { id, data }) {
      try {
        commit("SET_LOADING", true);

        const token = state.token || Cookies.get("token");
        if (!token) {
          throw new Error("Authentication token not found");
        }

        let response;
        const config = {};

        if (data instanceof FormData) {
          config.headers = { "Content-Type": "multipart/form-data" };
          response = await api.post(`/users/${id}`, data, config);
        } else {
          response = await api.put(`/users/${id}`, data);
        }

        commit("UPDATE_USER", {
          id: id,
          ...response.data,
        });

        return response.data;
      } catch (error) {
        console.error("User update failed:", error);

        if (error.response?.status === 401) {
          commit("LOGOUT");
          window.location.reload();
        }

        if (error.response?.status === 422) {
          error.validationErrors = error.response.data.errors;
        }

        commit("SET_ERROR", error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit("SET_LOADING", false);
      }
    },
    
    async createUser({ commit }, userData) {
      try {
        const isFormData = userData instanceof FormData;
        const config = {};

        if (isFormData) {
          config.headers = { "Content-Type": "multipart/form-data" };
        }

        const response = await api.post(
          "/users",
          isFormData ? userData : {
            ...userData,
            is_active: userData.is_active,
          },
          config
        );

        commit("ADD_USER", response.data);
        return response.data;
      } catch (error) {
        if (error.response?.status === 422) {
          error.validationErrors = error.response.data.errors;
        }
        throw error;
      }
    },
    
    async deleteUser({ commit, state }, userId) {
      try {
        commit("SET_LOADING", true);

        const token = state.token || Cookies.get("token");
        if (!token) {
          throw new Error("Authentication token not found");
        }

        await api.delete(`/users/${userId}`);

        const response = await api.get("/users");

        commit("SET_USERS", response.data);
      } catch (error) {
        console.error("Failed to delete user:", error);

        if (error.response?.status === 401) {
          commit("LOGOUT");
          window.location.reload();
        }

        commit("SET_ERROR", error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async fetchRoles({ commit, state }) {
      try {
        const token = state.token || Cookies.get("token");
        if (!token) {
          throw new Error("Authentication token not found");
        }

        const response = await api.get("/roles");

        commit("SET_ROLES", response.data);
        return response.data;
      } catch (error) {
        console.error("Failed to fetch roles:", error);

        if (error.response?.status === 401) {
          commit("LOGOUT");
          window.location.reload();
        }

        throw error;
      }
    },
  },
  
  getters: {
    isAuthenticated: (state) => !!state.token,
    currentUser: (state) => state.user,
    currentTenant: (state) => state.tenant, 
    currentSchoolName: (state) => state.tenant?.name || "School", 
    isAdmin: (state) =>
      ["school_admin", "academic_manager"].includes(state.user?.role?.slug),
    isTeacher: (state) => state.user?.role?.slug === "teacher",
    isStudent: (state) => state.user?.role?.slug === "student",
    isGuardian: (state) => state.user?.role?.slug === "guardian",
    isFinance: (state) => state.user?.role?.slug === "finance",
    getUsers: (state) => state.users,
    getCurrentPage: (state) => state.currentPage,
    getTotalPages: (state) => state.totalPages,
    isLoading: (state) => state.isLoading,
    getError: (state) => state.error,
    getRoles: (state) => state.roles,
    hasPermission: (state) => (slug) => state.permSlugs.has(slug),
tenants: (state) => state.tenants,
isSuperAdmin: (state) => state.user?.role?.slug === "super_admin",
    isRole: (state) => (role) => {
      return state.user?.role?.slug === role;
    },
    
    can: (state) => (slug) => {
      const role = state.user?.role?.slug?.toLowerCase();
if (["super_admin", "school_admin"].includes(role)) return true;
      return state.permSlugs.has(slug);
    },
    
    canAny:
      (state, getters) =>
      (slugs = []) =>
        slugs.some((s) => getters.can(s)),
        
    canAll:
      (state, getters) =>
      (slugs = []) =>
        slugs.every((s) => getters.can(s)),
  },
});